import { refreshActionTypes } from '../actions/refreshActions';

const initialState = {
  refreshFn: () => {},
};

const refreshReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case refreshActionTypes.SET_REFRESH_FN:
      return {
        ...state,
        refreshFn: payload.refreshFn,
      };
    default:
      return state;
  }
};

export default refreshReducer;
